import EventEmitter from 'events'

class DialogEmitter extends EventEmitter {
  openDialog(name: string | string[], closeOthers?: boolean): void {
    this.emit('openDialog', name, closeOthers)
  }

  closeDialog(name: string | string[]): void {
    this.emit('closeDialog', name)
  }
}

const dialogEmitter = new DialogEmitter()
export default dialogEmitter
